import React from 'react';
import styles from '../StreamerInfoContent.module.scss';
import {SoopButtonIcon, SoopIcon, SoopTooltip} from '@soop-ui/soop-ui';
import {isMobileByUserAgent} from '@/hooks/channel/useDeviceDetection';
import clsx from 'clsx';
import {useStationData} from '@/stores/channel/station';
import {
  OUTER_LINK_TYPE,
  OuterLinkType,
} from '@/types/channel/setting/basic/basic.schema';
import useChannelClickLog from '@/hooks/channel/useChannelClickLog';
import {ChannelT} from '@/utils/i18n/channel';

const ExternalLink = ({className}: {className?: string}) => {
  const isMobile = isMobileByUserAgent();
  const {links} = useStationData();

  const {sendClickLog} = useChannelClickLog();

  const OUTER_LINK_INFO = {
    [OUTER_LINK_TYPE.FACEBOOK]: {
      icon: 'icoOutlinkFacebook',
      name: ChannelT('페이스북'),
      code: 'facebook',
    },
    [OUTER_LINK_TYPE.INSTAGRAM]: {
      icon: 'icoOutlinkInstagram',
      name: ChannelT('인스타그램'),
      code: 'instagram',
    },
    [OUTER_LINK_TYPE.YOUTUBE]: {
      icon: 'icoOutlinkYoutube',
      name: ChannelT('유튜브'),
      code: 'youtube',
    },
    [OUTER_LINK_TYPE.NAVER]: {
      icon: 'icoOutlinkCafe',
      name: ChannelT('네이버 카페'),
      code: 'naver',
    },
    [OUTER_LINK_TYPE.SOOP]: {
      icon: 'icoOutlinkSoop',
      name: 'SOOP',
      code: 'soop',
    },
  };

  const getOuterLinkInfo = (type: OuterLinkType) => {
    return (
      OUTER_LINK_INFO[type] ?? {
        icon: 'icoOutlinkLink',
        name: ChannelT('기타 외부링크'),
        code: 'outsidelink',
      }
    );
  };

  const outerLinkClick = async (code: string, linkUrl: string) => {
    const url = new URL(linkUrl);

    await sendClickLog('station_link', {
      link_code: code,
      lk_ht: url.hostname,
    });
    window.open(linkUrl, '_blank');
  };

  return (
    <>
      <dl className={clsx(styles.outLink, className)}>
        <dt>{ChannelT('외부 링크')}</dt>
        <dd className={styles.linkBox}>
          {links?.map((link, idx) => {
            const {icon, name, code} = getOuterLinkInfo(link.type);

            return (
              <React.Fragment key={`${link.linkName}-${idx}`}>
                {/* 모바일에서 툴팁 노출 방지를 위해 분기 */}
                {!isMobile ? (
                  <SoopTooltip
                    placement='bottom'
                    title={
                      link.linkName === '' ? name : ChannelT(link.linkName)
                    }
                    trigger='hover'
                    withArrow>
                    <button
                      type='button'
                      onClick={() => outerLinkClick(code, link.url)}
                      className={styles.pcLink}>
                      <SoopIcon name={icon} width='24px' height='24px' />
                    </button>
                  </SoopTooltip>
                ) : (
                  <SoopButtonIcon
                    circle
                    iconName={icon}
                    className={styles.link}
                    onClick={() => outerLinkClick(code, link.url)}
                    size={32}
                    iconWidth='24px'
                    iconHeight='24px'
                    variant='linePrimary'
                    title={name}
                    inheritColors={false}
                  />
                )}
              </React.Fragment>
            );
          })}
        </dd>
      </dl>
    </>
  );
};

export default ExternalLink;
